export default __webpack_public_path__ + "static/media/crion.4861e40f.webp";